import React from 'react';
import PropTypes from 'prop-types';
import { normalizeGameStatusKey } from '../utils/lockStatusUtils';
import './GameStatusBadge.css';
import './LivePulse.css';

const BADGE_CONFIG = {
  in_progress: { label: 'LIVE', className: 'game-status-badge--live' },
  completed: { label: 'FINAL', className: 'game-status-badge--final' },
  scheduled: { label: 'UPCOMING', className: 'game-status-badge--upcoming' },
};

const GameStatusBadge = ({ gameStatus, kickoff }) => {
  const statusKey = normalizeGameStatusKey(gameStatus, kickoff);
  const config = BADGE_CONFIG[statusKey];

  if (!config) {
    return null;
  }

  return (
    <span className={`game-status-badge ${config.className}`}>
      {config.label}
    </span>
  );
};

GameStatusBadge.propTypes = {
  gameStatus: PropTypes.string,
  kickoff: PropTypes.string,
};

export default GameStatusBadge;
